"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversations.date.today': 'Hoy',
    'conversations.date.yesterday': 'Ayer',
    'conversations.date.daysAgo': 'hace {days} días',
};
